import fetch from '../utils/fetch';
import { registrationUrl } from 'endpoints';

class SelfRegistraionSDK {
    // Create Org Unit Registration code by registration id
    createCode = ( data ) => {
        const regId = {
            registrationId: data
        };
        return new Promise( ( resolve, reject ) => {
            fetch( `${ registrationUrl }/registration-code`, {
                method: 'POST',
                headers: { 'content-type': 'application/json' },
                body: JSON.stringify( regId )
            } )
                .then( ( res ) => {
                    if ( res.ok ) {
                        res.json().then( ( codes ) => {
                            resolve( codes );
                        } );
                    } else {
                        res.json().then( ( data ) => {
                            reject( data.message );
                        } );
                    }
                } )
                .catch( ( err ) => {
                    console.error( err );
                    reject( err.message );
                } );
        } );
    };
    // Get Org Unit Registration code by registration id
    getCode = ( registrationId ) => {
        return new Promise( ( resolve, reject ) => {
            fetch( `${ registrationUrl }/registration-codes/${ registrationId }` )
                .then( ( res ) => {
                    if ( res.ok ) {
                        res.json().then( ( codes ) => {
                            resolve( codes );
                        } );
                    } else {
                        res.json().then( ( data ) => {
                            reject( data.message );
                        } );
                    }
                } )
                .catch( ( err ) => {
                    console.error( err );
                    reject( err.message );
                } );
        } );
    };
}

export default new SelfRegistraionSDK();